var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 4.85385L11.5551 1.45116C11.1914 1.08601 10.6983 0.880862 10.1841 0.880859H1.93891C0.868067 0.880859 0 1.7526 0 2.82799V19.7031C0 20.7785 0.868067 21.6502 1.93891 21.6502H13.5724C14.6432 21.6502 15.5113 20.7785 15.5113 19.7031V6.23067C15.5113 5.71426 15.307 5.21901 14.9434 4.85385ZM13.4156 6.0732H10.3409V2.98546L13.4156 6.0732ZM1.93891 19.7031V2.82799H8.40195V7.04676C8.40195 7.58445 8.83598 8.02033 9.3714 8.02033H13.5724V19.7031H1.93891Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10299 14.1051L5.62983 12.007H6.72355L5.63599 15.3405H4.57616L3.4886 12.007H4.5854L5.10299 14.1051Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12843 15.3405H7.08709V12.007H8.12843V15.3405ZM7.02547 11.1474C7.02547 10.9996 7.07888 10.8784 7.18568 10.7839C7.29248 10.6894 7.43112 10.6422 7.6016 10.6422C7.77208 10.6422 7.91072 10.6894 8.01752 10.7839C8.12433 10.8784 8.17773 10.9996 8.17773 11.1474C8.17773 11.2953 8.12433 11.4165 8.01752 11.511C7.91072 11.6055 7.77208 11.6527 7.6016 11.6527C7.43112 11.6527 7.29248 11.6055 7.18568 11.511C7.07888 11.4165 7.02547 11.2953 7.02547 11.1474Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63986 13.6491C8.63986 13.1213 8.75386 12.7053 8.98184 12.4014C9.20983 12.0974 9.52819 11.9454 9.93692 11.9454C10.2347 11.9454 10.4853 12.0625 10.6887 12.2966V10.6083H11.73V15.3405H10.7965L10.7441 14.9832C10.5305 15.2625 10.2594 15.4022 9.93076 15.4022C9.53435 15.4022 9.2201 15.2502 8.988 14.9462C8.75591 14.6422 8.63986 14.2098 8.63986 13.6491ZM9.67813 13.7138C9.67813 14.3054 9.85066 14.6011 10.1957 14.6011C10.4258 14.6011 10.5901 14.5046 10.6887 14.3115V13.0422C10.5942 12.845 10.4319 12.7464 10.2019 12.7464C9.88146 12.7464 9.70791 13.0052 9.68121 13.5228L9.67813 13.7138Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.880859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2a7ecad9960ddf22d6799cd2541b660a.svg";
export { ForwardRef as ReactComponent };